/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * エピソードのコンテンツ内の要素
 * @export
 * @interface ElementModel
 */
export interface ElementModel {
    /**
     * 
     * @type {string}
     * @memberof ElementModel
     */
    type?: ElementModelTypeEnum;
    /**
     * アラインメント
     * @type {string}
     * @memberof ElementModel
     */
    align?: ElementModelAlignEnum;
    /**
     * 
     * @type {Array<ElementModel>}
     * @memberof ElementModel
     */
    children?: Array<ElementModel>;
    /**
     * 
     * @type {string}
     * @memberof ElementModel
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementModel
     */
    service?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementModel
     */
    html?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementModel
     */
    src?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ElementModel
     */
    bold?: boolean;
    /**
     * 画像のURL
     * @type {string}
     * @memberof ElementModel
     */
    url?: string;
    /**
     * 
     * @type {number}
     * @memberof ElementModel
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof ElementModel
     */
    height?: number;
    /**
     * type="viewer"の場合に設定されるビューワーID
     * @type {string}
     * @memberof ElementModel
     */
    viewerId?: string;
}


/**
 * @export
 */
export const ElementModelTypeEnum = {
    Paragraph: 'paragraph',
    Header: 'header',
    Quote: 'quote',
    Image: 'image',
    Link: 'link',
    Viewer: 'viewer',
    Embed: 'embed',
    Html: 'html'
} as const;
export type ElementModelTypeEnum = typeof ElementModelTypeEnum[keyof typeof ElementModelTypeEnum];

/**
 * @export
 */
export const ElementModelAlignEnum = {
    Left: 'left',
    Center: 'center',
    Right: 'right'
} as const;
export type ElementModelAlignEnum = typeof ElementModelAlignEnum[keyof typeof ElementModelAlignEnum];


/**
 * Check if a given object implements the ElementModel interface.
 */
export function instanceOfElementModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ElementModelFromJSON(json: any): ElementModel {
    return ElementModelFromJSONTyped(json, false);
}

export function ElementModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'align': !exists(json, 'align') ? undefined : json['align'],
        'children': !exists(json, 'children') ? undefined : ((json['children'] as Array<any>).map(ElementModelFromJSON)),
        'text': !exists(json, 'text') ? undefined : json['text'],
        'service': !exists(json, 'service') ? undefined : json['service'],
        'html': !exists(json, 'html') ? undefined : json['html'],
        'src': !exists(json, 'src') ? undefined : json['src'],
        'bold': !exists(json, 'bold') ? undefined : json['bold'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'viewerId': !exists(json, 'viewerId') ? undefined : json['viewerId'],
    };
}

export function ElementModelToJSON(value?: ElementModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'align': value.align,
        'children': value.children === undefined ? undefined : ((value.children as Array<any>).map(ElementModelToJSON)),
        'text': value.text,
        'service': value.service,
        'html': value.html,
        'src': value.src,
        'bold': value.bold,
        'url': value.url,
        'width': value.width,
        'height': value.height,
        'viewerId': value.viewerId,
    };
}

